"use client";
const e = [
  "a",
  "an",
  "the",
  "and",
  "as",
  "but",
  "or",
  "nor",
  "at",
  "by",
  "in",
  "of",
  "on",
  "per",
  "to",
  "up",
  "via",
  "vs",
  "with",
  "is",
  "it",
  "for",
  "are",
  "not",
  "out",
  "off",
  "yet",
  "so",
  "be",
  "if",
  "has",
  "its",
  "we",
  "our",
  "any",
  "all",
  "how",
  "her",
  "his",
  "their",
  "was",
  "were"
];
export {
  e as lowercase
};
